<template>
    <!-- <div :ref="refName" class="rent-checkbox" @click="myCheck">
        <span v-bind:style="checkBoxColor">
            <img v-show="isChecked" :src="checkedImg" alt="">
        </span>
        {{checkboxMsg}}
    </div> -->
    <div>
        <label class="rent-checkbox">
            <span v-bind:style="checkBoxColor">
                <img v-show="isChecked" :src="checkedImg" alt="">
            </span>
            <input type="checkbox" :value="val" v-model="checked" @change="onChange" />
            {{checkboxMsg}}
        </label>
    </div>
</template>
<script>
export default {
    name: 'rentCheckbox',
    data () {
        return {
            isChecked: this.isPropChecked,
            checkVal: '',
            checkedImg: '',
            checkBoxColor: {
                background: this.bgColor,
                border: '1px solid '+this.borderColor
            }
        }
    },
    props: {
        checkboxMsg: String,
        borderColor: String,
        bgColor: String,
        tickColor: String,
        val: '',
        value: '',
        isPropChecked: {
            default: true,
            type: Boolean
        },
        setDefault: Boolean
    },
    mounted () {
        this.setTickColor();
    },
    watch: {
        isPropChecked: function (val) {
            this.isChecked = val
        },
        setDefault: function () {
            if(this.setDefault){
                this.isChecked = this.setDefault
            }
            // console.log(this.setDefault)
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = !this.isChecked;
            this.$emit('input', this.checkVal)
        },
        setTickColor: function () {
            if( this.tickColor == 'black' ){
                this.checkedImg = require('@/assets/img/component/widge/checkbox/tick_black.svg');
            }else if( this.tickColor == 'white' ){
                this.checkedImg = require('@/assets/img/component/widge/checkbox/tick_white.svg');
            }
        },
    }
}
</script>
<style   lang="scss">
    .rent-checkbox{
        position: relative;
        display: flex;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
        span{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            font-weight: 300;
            margin-right: 8px;
            border-radius: 3px;
            background: #ccc;
        }
        input{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/RentCheckbox.vue